// extracted by mini-css-extract-plugin
export default {"sectionTitle":"AddonsSectionMaybe_sectionTitle__dgfne","itemSection":"AddonsSectionMaybe_itemSection__lF9Lc","sectionAddons":"AddonsSectionMaybe_sectionAddons__cFOkC"};